import { Enum } from 'enumify-mod';

class Countries extends Enum {
	static USA;
	static ROMANIA;
	static HONGKONG;
	static CANADA;
}

Countries.initEnum({
	USA: 'US',
	CANADA: 'CA',
	ROMANIA: 'RO',
	HONGKONG: 'HK'
});

// todo get from db
export const EU_COUNTRIES = ['AT', 'BE', 'BG', 'CY', 'CZ', 'DE', 'DK', 'EE', 'GR', 'ES', 'FI', 'FR', 'HR', 'HU', 'IE', 'IT', 'LT', 'LU', 'LV', 'MT', 'NL', 'PL', 'PT', 'RO', 'SE', 'SI', 'SK'];

export default Countries;



// WEBPACK FOOTER //
// ./enums/Countries.js